<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">{{ data.headline }}</div>

    <div class="modal-body">
      <p [innerHtml]="data.message "></p>

    </div>
    <div class="modal-footer">
      @if (data.actionName) {
        <span class="modal-footer-left">
          <button type="button" class="btn cl-color-secondary it-cancel"
                  (click)="dialogRef.close()">
              <span>Cancel</span>
          </button>
        </span>
        <span class="modal-footer-center"></span>
        <span class="modal-footer-right">
          <button type="button" class="btn cl-color-primary it-ok" [class.cl-btn-spinner]="performing"
                  (click)="performAction()"
                  [disabled]="performing"
          >
              <span>{{ data.actionName }}</span>
          </button>
        </span>
      } @else {
        <span class="modal-footer-left"></span>
        <span class="modal-footer-center">
          <button type="button" class="btn cl-color-secondary"
                  (click)="dialogRef.close()">
              <span>Close</span>
          </button>
        </span>
        <span class="modal-footer-right"></span>
      }
    </div>
  </div>
</div>
